import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  selectMFClassicComparatorInitialDateDiff,
  selectMFClassicComparatorFinalDateDiff,
} from 'redux/reducers/meteorologyFieldsClassicComparatorControlPanelReducer';
import { clampedDefaultInterval } from 'helper/Meteorology/Fields/ClassicComparator/periodDefaults';
import useClassicComparatorDates from 'utils/hooks/meteorology/classicComparator/useClassicComparatorDates';

export default function useApplyClassicComparatorDefaultInterval() {
  const { possibleIntervals, setInitialDate, setFinalDate } = useClassicComparatorDates();
  const initialDateDiff = useSelector(selectMFClassicComparatorInitialDateDiff);
  const finalDateDiff = useSelector(selectMFClassicComparatorFinalDateDiff);

  useEffect(() => {
    if (possibleIntervals.length === 0) return;
    if (initialDateDiff !== undefined || finalDateDiff !== undefined) return;

    const interval = clampedDefaultInterval(possibleIntervals, new Date());
    if (!interval) return;
    setInitialDate(interval.start);
    setFinalDate(interval.end);
  }, [possibleIntervals, initialDateDiff, finalDateDiff, setInitialDate, setFinalDate]);
}
